import { i18n } from "@/i18n";

/**
 * 메뉴 이름을 동적으로 i18n으로 번역하는 함수
 * @param menuName DB에서 받아온 메뉴 이름 (영어 키)
 * @param fallback 메뉴 이름이 없을 때 사용할 기본값
 * @returns 번역된 메뉴 이름
 */
export function getMenuTranslation(menuName: string, fallback?: string): string {
  if (!menuName) {
    return fallback || "";
  }

  // menus. 접두사를 붙여서 언어팩에서 찾기
  const translationKey = `menus.${menuName}`;

  try {
    // i18n 인스턴스를 직접 사용하여 번역
    const translation = i18n.global.t(translationKey);

    // 번역이 키와 같다면 (즉, 번역이 없다면) 원본 반환
    if (translation === translationKey) {
      return fallback || menuName;
    }

    return translation;
  } catch (error) {
    // 번역 실패 시 원본 또는 fallback 반환
    return fallback || menuName;
  }
}

/**
 * 메뉴 객체에서 번역된 이름을 가져오는 함수
 * @param menu 메뉴 객체
 * @returns 번역된 메뉴 이름
 */
export function getTranslatedMenuName(menu: any): string {
  const menuName = menu.menuName || menu.menuNm || menu.name;
  return getMenuTranslation(menuName, menuName);
}

/**
 * 메뉴 배열의 모든 메뉴 이름을 번역하는 함수
 * @param menus 메뉴 배열
 * @returns 번역된 메뉴 배열
 */
export function translateMenuNames(menus: any[]): any[] {
  return menus.map(menu => ({
    ...menu,
    translatedName: getTranslatedMenuName(menu),
    // 기존 name 필드도 번역된 값으로 업데이트 (하위 호환성)
    name: getTranslatedMenuName(menu),
  }));
}
